"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustedBrands() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const brands = [{
    id: 1,
    name: "Brand One",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/00o3LZDVKq4XQutQZev2jl2RUE1JFjezWV2VcHbu.png?v=mdy3wro5wk"
  }, {
    id: 2,
    name: "Brand Two",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/520520520.png?v=nd828i4fv8"
  }, {
    id: 3,
    name: "Brand Three",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/FLORAA.png?v=hg1sc2r5jto"
  }, {
    id: 4,
    name: "Brand Four",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/65465461320520.png?v=2zwwjcx2zag"
  }, {
    id: 5,
    name: "Brand Five",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/loreman.png?v=dgcblbvs1e"
  }, {
    id: 6,
    name: "Brand Six",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/SaudiGP25__ETG_LOGO-04.png?v=kcp1l3vbxla"
  }, {
    id: 7,
    name: "Brand Seven",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/X2dCSwiZT4Yp7l7mSjhFebrM1jeosUk0K2xTKGOG-1-2.png?v=vli08soqtjc"
  }, {
    id: 8,
    name: "Brand Eight",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/Tz8vKgIs8ITte2AXK7nW00AQJoNt98su4IZM8EQn.png?v=psal5r30aa9"
  }, {
    id: 9,
    name: "Brand Nine",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/PF5l5gGwKFABUQP1kbcN40LlHAWyL6BlbY39BmTU-1.png?v=gvf8ctz70tk"
  }, {
    id: 10,
    name: "Brand Ten",
    logo: "https://media1pro.com/wp-content/uploads/2026/02/Agave-rrest-logo-2.png?v=xwr4wiwg6w"
  }];
  return <section id="trusted-brands" ref={ref} className="bg-dark-background py-16 sm:py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12 lg:gap-16">
          {brands.map((brand, i) => <div key={brand.id} data-index={i} className={`group relative transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible ? `${i * 200}ms` : "0ms"
        }}>
              <div className="relative">
                <img src={brand.logo} alt={brand.name} className="h-12 w-auto object-contain opacity-50 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] !rounded-none !m-0 sm:h-14" />
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" style={{
              transformOrigin: "bottom"
            }} />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}